/**
 * Formats a date string or Date object to a readable format
 * @param date - Date string or Date object
 * @param includeTime - Whether to include time in the formatted string
 */
export function formatDate(date: string | Date, includeTime: boolean = true): string {
	const dateObj = typeof date === 'string' ? new Date(date) : date;
	
	if (isNaN(dateObj.getTime())) {
		return 'Invalid Date';
	}
	
	const options: Intl.DateTimeFormatOptions = {
		year: 'numeric',
		month: 'short',
		day: 'numeric'
	};
	
	if (includeTime) {
		options.hour = '2-digit';
		options.minute = '2-digit';
	}
	
	return dateObj.toLocaleString('en-US', options);
}

/**
 * Checks if a date is in the past
 * @param date - Date string or Date object
 */
export function isPastDate(date: string | Date): boolean {
	const dateObj = typeof date === 'string' ? new Date(date) : date;
	return dateObj < new Date();
}

/**
 * Checks if a date is in the future
 * @param date - Date string or Date object
 */
export function isFutureDate(date: string | Date): boolean {
	const dateObj = typeof date === 'string' ? new Date(date) : date;
	return dateObj > new Date();
}

/**
 * Checks if current date is between start and end dates
 * @param startDate - Start date
 * @param endDate - End date
 */
export function isDateInRange(startDate: string | Date, endDate: string | Date): boolean {
	const now = new Date();
	const start = typeof startDate === 'string' ? new Date(startDate) : startDate;
	const end = typeof endDate === 'string' ? new Date(endDate) : endDate;
	
	return now >= start && now <= end;
}

/**
 * Converts a date to ISO string format for datetime-local input
 * @param date - Date object
 */
export function toDateTimeLocalString(date: Date): string {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');
	
	return `${year}-${month}-${day}T${hours}:${minutes}`;
}
